import { Col, Row, Skeleton } from "antd"

const DescriptionSkeleton = () => {

  return (
    <Col
      span={24}
    >
      <Row justify="center" style={{ marginBlock: '1rem' }}>
        <Col className="page__section ql-editor">
          <Skeleton />
        </Col>
      </Row>
    </Col>
  )
}

export default DescriptionSkeleton